<template>
  <div class="confirm-order-container">
    <van-nav-bar :title="$route.meta.title">
      <template #left>
        <van-icon @click="back" name="arrow-left" color="#46474B" size="20px" />
      </template>
    </van-nav-bar>
    <div class="confirm-order-top">
      <NoticeListBar class="notice-box" :show-head-img="true" />
    </div>
    <!-- <div class="notice">
      <Notice icon-size="16" icon="info-o">
        您的问题已成功提交，支付后可接入律师咨询
      </Notice>
    </div> -->

    <div class="wrap">
      <!-- <div v-if="$route.query.type!=='2'">
        <p class="title">
          案件概述
        </p>
        <CaseInformation :case-source-data="caseSourceData" />
      </div> -->
      <div class="steps" v-show="serverData.type === 1 || serverData.type === 3">
        <span class="steps-item flex flex-align-center"><span>1.支付订单 </span><img src="@/assets/common/sysarrow2-yellow.png" alt=""></span>
        <span class="steps-item flex flex-align-center">2.{{serverData.type === 1 ? '极速响应' : '律师接单'}} <img src="@/assets/common/sysarrow2-yellow.png" alt=""></span>
        <span class="steps-item flex flex-align-center">3.极速服务 <img src="@/assets/common/sysarrow2-yellow.png" alt=""></span>
        <span class="steps-item flex flex-align-center">4.服务评价 </span>
      </div>
      <p :class="['title',serverData.type===2&&'title-t']">
        购买服务<span>下单后即可联系律师</span>
      </p>
      <div class="pay-card free-c card-active">
        <div class="pay-card-top">
          <span class="right-text">极速{{ serverData.type === 2 ? '通道' : '响应' }}</span>
          <div>
            <div class="flex">
              <img class="dicon" :src="serverData.icon" alt="">
              <div class="flex flex-column flex-space-between">
                <span class="titlename">{{ serverData.serviceName }}</span>
                <div class="flex">
                  <div v-if="serverData.serviceNum && serverData.unitLabel" class="flex info">
                    <div class="sub-t font12">
                      购买规格: {{ serverData.serviceNum + serverData.unitLabel }}
                    </div>
                    <div class="price">
                      <p class="origin-price">
                        ¥{{ amountFilter(serverData.originalPrice) }}
                      </p>
                      <p class="servicePrice-price">
                        ¥{{ amountFilter(serverData.servicePrice) }}
                      </p>
                    </div>
                  </div>
                  <div v-else class="sub-price">
                    ¥{{ amountFilter(serverData.servicePrice) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="infobox">
          <div class="rate">
            <van-rate readonly :value="5" :count="5" size="0.4rem" gutter="0.3rem" color="#FFA701" :void-icon="icon"
                      :icon="iconSelected" void-color="#DCDFE4" class="rate-item-star"
            />
            99%好评
          </div>
          <div class="count">
            {{ serverData.buyersNums }}<span>人已付款</span>
          </div>
        </div>
      </div>
      <!-- 1v1 -->
      <div v-if="serverData.type === 1" class="onevone font12">
        您正在购买<img alt="" :src="lawyerData.imgUrl" srcset="" class="img">{{ lawyerData.realName }}律师的服务,支付成功后立即进入一对一咨询
      </div>
      <!-- 2.lawsuitShare.3新添加公共咨询付费类型 -->
      <div v-else-if="serverData.type === 3" class="common-info">
        <div class="lawyer" v-show="commonLawyerList.length">
            <p class="sb-title font13">
              <span>以下律师将会为您服务：</span><span class="desc">全国累计1万余名律师入驻</span>
            </p>
          <div class="lawyer-list flex">
            <div v-for="(item,index) in commonLawyerList.slice(0,10)" :key="index+'commonLawyerList'" class="item">
              <img :src="item.imgUrl || require(`@/assets/imgs/plusPage/headimg.png`)" alt="" srcset="">
              <p class="name font10">
                 {{ item.realName || '律师' }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- 加急 -->
      <div v-else class="other font12">
        你正在购买平台加急服务，支付成功可享受金牌律师优先为你解决问题
      </div>

    </div>
    <div class="handle-bottom">
      <div class="payway-box">
        <div class="payway flex flex-space-between flex-align-center" v-for="(item,index) in payList" :key="index+'payList'" @click="selectPayWay(item)">
          <div class="flex flex-align-center">
            <img class="wxpayicon" :src="item.icon" alt="">
            <span>{{item.title}}</span>
          </div>
          <img class="payselect" :src="require(`@/assets/common/${payWay!==Number(item.code)?'zx_nocheck' : 'payselect'}.png`)">
        </div>
      </div>
      <div class="bt" @click="toCreateOrder">
        立即支付 ¥{{ amountFilter(serverData.servicePrice) }}
      </div>
    </div>
  </div>
</template>

<script>
/**
 * type 0-其他服务(历史服务), lawsuitShare-1V1服务, 2-案源付费服务,3-1v1公共咨询服务
 */


// 这个页面不需要更改---------------------------------------------------------------------------
import { NavBar,Icon,Rate } from 'vant'
import NoticeListBar from '@/components/notice-list-bar'
// import Notice from '@/components/layout/notice'
// import ServiceProcess from '@/components/layout/service-process'
// import { createOrder, orderPay, serviceManegeInfo, caseSourceV2GetInfo,oneLawyer } from '@/api'
import { createOrder,getCommonConfigKey, serviceManegeInfo,oneLawyer,getCommonLawyer } from '@/api'
// import { getServiceCasePaySetTime } from '@/libs/tool'
import { amountFilter } from '@/libs/filter'
import { callApp } from "@/libs/bridge";
import { buriedPoint,buriedChannelPoint} from '@/api/common'
import { BURY_POINT_TYPE,BEHAVIOR } from '@/libs/config'
import { toPay } from '@/libs/tool'
// import CaseInformation from './components/case-information.vue'

export default {
  name: 'Index',
  components: {
    NoticeListBar,
    'van-nav-bar': NavBar,
    'van-icon': Icon,
    'van-rate': Rate
    // Notice,
    // CaseInformation
    // ServiceProcess,
  },
  data(){
    return{
      // paidServiceTime: '', // 已支付的服务时间
      serverData: {}, // 服务信息
      // caseSourceData: {}, //案源信息
      lawyerData: {}, // 律师信息
      serviceCode: '',//兼容老版本app没传服务code
      commonLawyerList: [],// 公共律师列表
      icon: require('@/assets/confirm-order/star.png'),
      iconSelected: require('@/assets/confirm-order/star1.png'),
      payList: [], // 支付方式
      payWay: 2, // 默认微信官方
    }
  },
  watch:{
    '$route.query.serviceCode'(val){
      if(val && val !=='0'){
        this.getServiceInfo()
        this.init()
      }
    },
    serviceCode(val){
      if(val){
        this.getServiceInfo()
        this.init()
      }
    }
  },
  async mounted(){
        /* 获取支付方式 */
    getCommonConfigKey({ paramName: 'FL_PAY_TYPE_LIST' }).then(({ data }) => {
      if (data.paramValue) {
        this.payList = JSON.parse(data.paramValue)
        this.payWay = Number(this.payList[0].code) || 2
      }
    })
    // this.addListenerBack()
    window.physicsBackFn = this.back
    // this.init()
    // await this.getServiceInfo()
    const {serviceCode} = this.$route.query
    if(serviceCode && serviceCode!=='0'){
      await this.getServiceInfo()
      this.init()
    }else{
      await this.getCode()
    }
  },
  methods: {
    filterUndefined (val) {
      if (val && val !== 'undefined') {
        return val
      } else {
        return null
      }
    },
        /** 选择支付方式 */
    selectPayWay (item) {
      this.payWay = Number(item.code)
    },
    amountFilter,
    // 获取公共律师列表数据
    async getCommonLawyerList(){
      try {
        let res = await getCommonLawyer()
        this.commonLawyerList = res.data || []
      } catch (error) {
        console.log(error)
      }
    },
    async bury(point){
       // 埋点
      const {serviceCode} = this.$route.query
      let params = {
        point,
        code: 'LAW_USER_EARNING_COUNT',//用户收益相关埋点
        extra:{
          serviceCode: serviceCode && serviceCode!=='0' ? Number(serviceCode) : Number(this.serviceCode),
          transformationPath:Number(this.$route.query.transformationPath) || 0
        }
      };
      await buriedPoint(params);
    },
    // 页面访问埋点
    buryPointPage(){
      const {serviceCode} = this.$route.query
      let params = {
        code: 'LAW_PAGE_ORDER_SURE',
        type: BURY_POINT_TYPE.PAGE,
        behavior: BEHAVIOR.VI,
        extra:{
          serverCode:serviceCode && serviceCode!=='0' ? Number(serviceCode) : Number(this.serviceCode),
          transformationPath:Number(this.$route.query.transformationPath) || 0,
          newUser:true
        }
      }
      buriedChannelPoint(params)
    },
    back(){
      /**
       * 参数 backAlert    2.lawsuitShare.lawsuitShare(0:直接返回 lawsuitShare：案源拦截  2：1v1拦截 3:公共咨询付费类型)
       * */
      switch(Number(this.$route.query.backAlert)){
        case 1:
          callApp('showDiscountAlert')
          break
        case 2:
        case 3:
          callApp('showOneToOneAlert')
          break
        case 0:
        default:
          callApp('finishActivity')
          break
      }
    },
    async init(){
      localStorage.setItem('transformationPath',JSON.stringify(this.$route.query.transformationPath || 0))

      // 确认订单页面埋点
      await this.buryPointPage()
      // 支付页访问(必须登录)
      await this.bury(2)
      // 已支付获取服务时间
      // getServiceCasePaySetTime().then((data) => {
      //   this.paidServiceTime = data
      // })
      // 1v1获取律师信息
      this.serverData.type === 1 && this.getLawyerData()
       /** 公共付费咨询时获取律师列表 */
      this.serverData.type === 3  && await this.getCommonLawyerList()
    },
    // 获取拦截服务code
    async getCode(){
      getCommonConfigKey({ paramName: 'law_pay_return_interceptor_default_service_code' }).then(async ({ data }) => {
        if(data.paramValue){
          this.serviceCode = data.paramValue
        }
      })
    },
    // 获取服务配置信息
    async getServiceInfo(){
      localStorage.setItem('transformationPath',JSON.stringify(this.$route.query.transformationPath || 0))
      const {serviceCode} = this.$route.query
      try {
        let res = await serviceManegeInfo(Number(serviceCode && serviceCode!=='0' ? serviceCode : this.serviceCode))
        if(res.data){
          this.serverData = res.data
        }
      } catch (error) {
        console.log(error)
      }
    },
    /** 获取律师信息 */
    async getLawyerData(){
      try {
        const { lawyerId } = this.$route.query
        const obj = await oneLawyer({ id: lawyerId })
        this.lawyerData = obj.data
      } catch (error) {
        console.log(error)
      }
    },
    async toCreateOrder(){
      // 20220923 synWdIdaa之前逻辑
      // const { serviceCode, businessId,orderId,lawyerId } = this.$route.query
      // const { type = lawsuitShare } = this.serverData
      // const typeParam = (type === 3 || type === lawsuitShare) ? 2 : lawsuitShare
      // let serverCodeParam = serviceCode && serviceCode!=='0' ? serviceCode : this.serviceCode
      // synWdId 问题信息 v2.2.8新增 主要用于落地页公共付费咨询带信息入库 需要同步的问答id对应的信息
      const { serviceCode, businessId, orderId, lawyerId, synHistoryId, synWdId } = this.$route.query
      const { type = 1 } = this.serverData
      let typeParam = 1
      switch (type) {
        case 1:
        case 3:
          typeParam = 2
          break
        case 2:
          typeParam = 1
          break
        case 4:
          typeParam = 3
          break
        case 5:
          typeParam = 4
          break
        case 6: // 免费追问过来
          typeParam = 5
          break
      }
      const serverCodeParam = serviceCode && serviceCode !== '0' ? serviceCode : this.serviceCode


      if(orderId){
          this.toPayNow(orderId)
      }else{
        try {
          const params = {
            serviceCode: serverCodeParam,
            businessId: this.filterUndefined(businessId),
            type: typeParam,
            lawyerId: this.filterUndefined(lawyerId),
            synHistoryId: this.filterUndefined(synHistoryId),
            synWdId: this.filterUndefined(synWdId)
          }
          // 20220923 synWdIdaa之前逻辑
          // let respOrder =  await createOrder({ serviceCode: serverCodeParam, businessId: businessId||null,type: typeParam,lawyerId:lawyerId || null })
          let respOrder =  await createOrder(params)
          if(respOrder){
            this.toPayNow(respOrder.data.orderId)
          }
        } catch (error) {
          console.log(error)
        }
      }
    },
    async toPayNow(orderId){
      // 发起支付按钮(必须登录)
     await this.bury(3)
     const a = this.$toast.loading('加载中')
      return toPay({
        orderId,
        payType: this.payWay,
        redirectPath: '/confirm-order/pay-loading'
      }).then(({ data }) => {
        a.clear()
        return data
      }).catch(() => {
        a.clear()
      })
      // try {
      //   let params = {
      //     orderId,
      //     // payType: 2
      //     payType: this.payWay,
      //   }
      //   let resp = await orderPay(params)
      //   if(!resp.data.free){
      //     window.location.href = JSON.parse(resp.data.payResultMsg).h5_url
      //   }else{
      //     this.$toast('此订单免费！')
      //   }
      // } catch (error) {
      //   console.log(error)
      // }
    },
  }
}
</script>

<style scoped lang="scss">
.confirm-order-container{
  background: #fff;
  height: 100vh;
  overflow-y: auto;
  padding-bottom: 160px;
  box-sizing: border-box;
}
.onevone{
  width: 100%;
  width: 343px;
  font-size: 12px;
  line-height: 18px;
  margin-left: 16px;
  .img{
    font-size: 0;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    margin: 0 2px;margin-bottom: -5px;
  }
}
.other{
  color: #333;
  font-size: 12px;
  line-height: 18px;
  padding: 0 16px;
}
.common-info{
  // width: 343px;
  width: 375px;
  padding-left: 16px;
  overflow: hidden;
  margin-top: 26px;
  box-sizing: border-box;
  .lawyer{
    color:#222;

    // padding: 12px 0 16px 17px;
    .sb-title{
      font-size: 13px;
      font-weight: 600;
      margin-bottom: 11px;
      display: flex;
      justify-content: space-between;
      padding-right: 16px;
      .desc{
        color: #177EFF;
        font-weight: normal;
      }
    }
    &-list{
      overflow: auto;
      scrollbar-width: none; /* firefox */
      -ms-overflow-style: none; /* IE 10+ */
      // padding-right: 10px;
      &::-webkit-scrollbar {
        display: none; /* Chrome Safari */
      }
      .item{
        flex-shrink: 1;
        margin-right: 30px;
        display: flex;
        flex-direction: column;
        align-items: center;
        img{
          width: 68px;
          height: 68px;
          margin-bottom: 4px;
          border-radius: 50%;
        }
        .name{
          font-size: 13px;
          // transform: scale(0.9);
          // transform-origin: left center;
        }
      }
    }
  }
}
.confirm-order-top{
  background: url("~@/assets/confirm-order/jisubc.png") no-repeat left top;
  background-size: 375px;
  width: 375px;
  height: 167px;
  padding: 18px 16px 0 16px;
  box-sizing: border-box;
  .notice-box{
    width: 258px;
    height: 24px;
    background: rgba(0, 0, 0, 0.3);
    border-radius: 58px 58px 58px 58px;
    z-index: 1;
  }
   ::v-deep .van-notice-bar{
    color: rgba($color: #fff, $alpha: 0.9);
    font-size: 13px;
    padding: 0 6px;
  }
}
.wrap{
  border-radius: 16px 16px 0 0;
  margin-top: -36px;
  width: 100%;
  box-sizing: border-box;
  z-index: 2;
  background: #fff;
  .title{
    font-weight: bold;
    color: #000000;
    line-height: 19px;
    margin: 16px 0 12px 16px;
    font-size: 16px;
    // margin-bottom: 12px;
    // margin-top: 16px;
    span{
      font-size: 12px;
      color: #666;
      margin-left: 8px;
      font-weight: normal;
    }
  }
  .title-t{
    margin-top: -12px;
    padding-top: 12px;
  }
  .steps{
    padding: 0 16px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 375px;
    height: 38px;
    border-radius: 16px 16px 8px 8px;
    font-size: 12px;
    line-height: 14px;
    color: #BD5B02;
    img{
      display: inline-block;
      width: 12px;
      height: 12px;
      margin-left: 3px;
    }
  }
  .pay-card{
    box-sizing: border-box;
    font-size: 13px;
    border-radius: 10px 10px 10px 10px;
    margin-left: 16px;
    border: 2px solid #F5F5F5;
    &-top{
      padding: 12px;
    }
    .dicon{
      width: 44px;
      height: 44px;
      margin-right: 12px;
      border-radius: 8px;
    }
    .titlename{
      font-weight: 600;
      color: #333333;
      line-height: 19px;
      margin-bottom: 0;
    }
    .info{
      width: 260px;
      justify-content: space-between;
      .sub-t{
        color: #999999;
      }
      .price{
        display: flex;
        align-items: center;
        .origin-price{
          text-decoration: line-through;
          color: #999999;
          font-size: 12px;
          margin-right: 8px;
        }
        .servicePrice-price{
          color: #F34747;
          font-weight: bold;
          font-size: 16px;
        }
      }
    }
    .sub-title{
      color: #999999;
      margin-right: 8px;
    }
    .sub-price{
      font-size: 16px;
      color: #F34747;
      font-weight: bold;
    }
    .infobox{
      display: flex;
      justify-content: space-between;
      color: #F97724;
      font-size: 12px;
      height: 30px;
      background: #FFFAF0;
      padding: 0 16px;
      box-sizing: border-box;
      border-radius: 0 0 10px 10px;
      .rate{
        display: flex;
        align-items: center;
      }
      .rate-item-star{
        margin-top: 2px;
      }
      ::v-deep .van-rate__icon{
        width: 18px;
      }
      ::v-deep .van-rate__item{
        padding-right: 0 !important;
        margin-left: -4px;
      }
      .count{
        display: flex;
        align-items: center;
        span{
          color: #444;
          margin-left: 4px;
          margin-bottom: 2px;
        }
      }
    }
  }
  .free-c{
    position: relative;
    width: 343px;
    border-radius: 10px 10px 10px 10px;
    border: 2px solid #F5F5F5;
    margin-bottom: 12px;
    .update{
      width: 341px;
      height: 28px;
      background: #FFF2F2;
      border-radius: 0px 0px 10px 10px;
      font-size: 12px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #F34747;
      line-height: 28px;
      text-align: center;
      transform: translate(-12px,14px)
    }
    .right-text{
        position: absolute;
        right: 0px;
        top: 0px;
        font-size: 12px;
        font-weight: 400;
        color: #FFA700;
        width: 82px;
        height: 34px;
        line-height: 24px;
        text-indent: 25px;
        background-image:url('~@/assets/common/Subtract@2x(2).png') ;
        background-size: 100% 100%;
      }
    &.card-active .right-text{
      background-image:url('~@/assets/common/Subtract@2x(2).png') ;
      color: #FFFFFF;
    }
  }
  .card-active{
    border: 2px solid #FFA700;
  }
}
.handle-bottom{
  width: 375px;
  position: fixed;
  bottom: 0px;
  z-index: 99;
  background: #fff;
  padding-bottom: 15px;
  .payway{
    width: 343px;
    height: 44px;
    font-size: 14px;
    font-weight: 400;
    color: #46474B;
    line-height: 16px;
    margin-left: 16px;
    .wxpayicon{
      width: 18px;
      height: 18px;
      margin-right: 5px;
      margin-bottom: 3px;
    }
    .payselect{
      width: 16px;
      margin-right: 3px;
      height: 16px;
    }
  }
  .bt{
    width: 343px;
    height: 44px;
    background: #FFA700;
    border-radius: 22px 22px 22px 22px;
    font-size: 16px;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 44px;
    text-align: center;
    margin-left: 16px;
  }
}
</style>
